import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import { LogService } from "../../../services/LogService";
import AutocompleteField from "../../../components/fields/autocompleteField/AutocompleteField.vue";
import TextField from "../../../components/fields/textField/TextField.vue";
import PeriodoField from "../../../components/fields/periodoField/PeriodoField.vue";
import TextAreaField from "../../../components/fields/textAreaField/TextAreaField.vue";

export default {
    name: "VisualizarLog",
    components: {
        Breadcrumb,
        TextField,
        AutocompleteField,
        TextAreaField,
        PeriodoField
    },
    data: () => ({
        tab: false,
        tabs: [
          'Detalhamento do Log'
        ],
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciamento de Logs',
                disabled: false,
                href: '/logs/gerenciar'
            },
            {
                text: 'Visualizar Log',
                disabled: true
            }
        ],
        log: {
            id: '',
            username: '',
            nome: '',
            identificador: '',
            data: '',
            entidade: '',
            evento: ''
        },
        itemSelected: []
    }),
    created() {
        this.carregarLog(this.$route.params.id);
    },
    methods: {
        async carregarLog(id) {
            try {
                const response = await LogService.show(id);


                if (response && response.data) {

                    this.log.id = response.data.id;
                    this.log.username = response.data.usuario.username;
                    this.log.nome = response.data.usuario.nome;
                    this.log.identificador = response.data.identificador;
                    this.log.data = response.data.data;
                    this.log.entidade = response.data.entidade.entidade;
                    this.log.evento = response.data.entidade.evento;
                    this.log.descricao = response.data.descricao;

                } else {
                    console.error('Não foi possível carregar a log');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao buscar a log', error);
            }
        }
    }
};
